"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.ProgressSkeleton = exports.ButtonSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../styles");
const ButtonSkeleton = exports.ButtonSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: '100%',
  height: 45,
  borderRadius: theme.spacing(5),
  [theme.breakpoints.up('sm')]: {
    width: 135
  }
}));
const TextSkeleton = exports.TextSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: 185,
  height: 21,
  marginBottom: theme.spacing(3)
}));
const ProgressSkeleton = exports.ProgressSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  width: '100%',
  height: 8,
  borderRadius: theme.spacing(0.8),
  marginBottom: theme.spacing(6)
}));
